import { Typography } from "@mui/material"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import SBPIconNoExt from "../../../components/SBPIconNoExt"
import {
  ButtonsContainer,
  ContentContainer,
  IconContainer,
  SourceDescription,
  StyledButton,
  TopContainer,
} from "./styled"

interface C2BPushErrorProps {
  onRetry: () => void
  onClose: () => void
  title: string
  description: string
}

const C2BPushError = ({
  onRetry,
  onClose,
  title,
  description,
}: C2BPushErrorProps) => (
  <ContentContainer>
    <TopContainer>
      <IconBox size="lg" color="yellow">
        <UIIcon iconName="errorTransfer" size={80} />
      </IconBox>
      <SourceDescription>
        {title}
      </SourceDescription>
      <Typography
        variant="subtitle1"
        sx={{ mt: "20px", color: "gray", lineHeight: 1.2 }}
      >
        {description}
      </Typography>
    </TopContainer>
    <IconContainer>
      <SBPIconNoExt size={60} />
    </IconContainer>
    <ButtonsContainer>
      <StyledButton variant="contained" onClick={onRetry}>
        Повторить
      </StyledButton>
      <StyledButton variant="contained" color="secondary" onClick={onClose}>
        Закрыть
      </StyledButton>
    </ButtonsContainer>
  </ContentContainer>
)

export default C2BPushError
